import { hypot } from './dmath';
export type Point = { x: number; y: number };

/** Only plain-point taps qualify. Renewals use exactly the same own-attacker
 * centroid test as new retreats; an active move alone is never evidence. */
export function retreatTap(unit: Point, tap: Point, attackers: readonly Point[], _active: boolean, onEnemy: boolean, plainPoint = true): boolean {
  if (!plainPoint || onEnemy || !attackers.length) return false;
  let x = 0, y = 0;
  for (const a of attackers) { x += a.x; y += a.y; }
  const dx = unit.x - x / attackers.length, dy = unit.y - y / attackers.length;
  // away = within about 100 degrees of straight back from the attackers, so a sideways step out of a duel counts and a
  // tap forward past their line does not
  const tx = tap.x - unit.x, ty = tap.y - unit.y, n = hypot(dx, dy) * hypot(tx, ty);
  return hypot(dx, dy) <= 0.5 || (n > 0 && (tx * dx + ty * dy) / n >= -0.2);
}

/** A destination's disk grows with sqrt(population) and the largest separation
 * diameter. The spare diameter accommodates packing against a wall/plinth. */
export function arrivalRadius(count: number, radius: number): number {
  return 0.25 + 2 * radius * (Math.sqrt(Math.max(1, count)) - 1);
}
